import { css } from '@emotion/react';
import theme from 'shared/styles/themes';

export default css({
  '&.active-channel-filters': {
    display: 'flex',
    gap: '5px',
    flexWrap: 'wrap',
    padding: theme.space[2],
  },
  '.active-channel-filters': {},
});
